<template>
	<div class="login">
		<el-dialog :visible.sync="$store.state.islogin" width="450px" @open="handleOpen" @close="handleClose">
			<i class="iconfont icon-guanbi" @click="handleClose()"></i>
			<div class="title">
				<img src="../assets/img/图片1.png" alt="" />
				<h3>自律平台 <span>•</span> 会员登录</h3>
			</div>
			<el-form :model="form" ref="myForm" :rules="rules">
				<el-form-item prop="loginName">
					<el-input v-model="form.loginName" placeholder="请输入会员证号/企业完整中文名称" clearable autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input type="password" v-model="form.password" placeholder="请输入密码" show-password clearable autocomplete="off"></el-input>
				</el-form-item>
				<!-- <el-form-item prop="validateCode">
                    <el-input v-model="form.validateCode" placeholder="请输入验证码" clearable autocomplete="off">
                        <template slot="append">
                            <img class="validateCodeImg" :src="validateCodeImg"  @click="getImg()">
                        </template>
                    </el-input>
                </el-form-item> -->
				<el-form-item>
					<el-button class="btn" @click="submitForm('myForm')">登录</el-button>
					<a @click="register()">申请入会</a>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
import { loginApi, getCmsDicts } from '../axios/request';
import { encryptText } from '../assets/js/jsencrypt/index';
import { setLocalStorageWithExpiry } from '../assets/js/localStorage';
export default {
	// eslint-disable-next-line vue/multi-word-component-names
	name: 'UserLogin',
	data() {
		return {
			pwdType: 'password',
			form: {
				loginName: '',
				password: '',
				validateCode: '',
			},
			validateCodeImg: '',
			rules: {
				loginName: [{ required: true, message: '请输入会员证号/企业完整中文名称', trigger: 'blur' }],
				password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
				validateCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
			},
		};
	},
	mounted() {
		this.getImg();
	},
	methods: {
		// 打开弹窗
		handleOpen() {
			this.form.loginName = '';
			this.form.password = '';
			this.form.validateCode = '';
			this.getImg();
		},
		// 关闭弹窗
		handleClose() {
			this.$store.commit('getLogin', false);
		},
		// 登录按钮事件
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.login();
				} else {
					return false;
				}
			});
		},
		// 登录
		async login() {
			let d = {
				loginName: this.form.loginName,
				password: encryptText(this.form.password),
				validateCode: this.form.validateCode,
			};
			const res = await loginApi(d);
			// console.log('登录', res);
			if (res != null && res.code == 200) {
				this.$store.state.token = res.data;
				setLocalStorageWithExpiry('token', res.data, 8 * 60 * 60 * 1000); //8小时过期
				this.handleClose();
				this.$message({
					message: '登录成功！',
					type: 'success',
				});
			} else {
				this.$message.error(res.msg);
			}
		},
		// 获得验证码
		getImg() {
			this.validateCodeImg = process.env.VUE_APP_BASE_URL_API + '/nkyxf/get-validate-code-img?' + new Date().getTime();
		},
		// // 跳转注册
		// register() {
		// 	this.$store.commit('getRegister', true)
		// },
		// 跳出注册弹窗
		async register() {
			const res = await getCmsDicts({});
			if (res != null && res.code == 200) {
				for (const [key, value] of Object.entries(res.data)) {
					localStorage.setItem(key, JSON.stringify(value));
				}
				this.$store.commit('getRegister', true);
			}
		},
	},
};
</script>

<style scoped>
:deep(.el-dialog) {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 0 !important;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 10px;
}

:deep(.el-dialog__header) {
	display: none;
}

:deep(.el-dialog__body) {
	padding: 20px 0 !important;
	width: 74%;
	color: var(--text-color2);
}

.icon-guanbi {
	position: absolute;
	top: 20px;
	right: 20px;
	font-size: 25px;
	color: #adadad;
	cursor: pointer;
}

.icon-guanbi:hover {
	color: #666;
}

.title {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 24px auto;
}

.title img {
	margin-right: 15px;
	width: 45px;
	height: 45px;
}

.title h3 {
	font-size: 1.4375rem;
}

.title span {
	color: #666;
}

:deep(.el-input__inner:focus) {
	border-color: var(--bg-color);
}

.validateCodeImg {
	cursor: pointer;
}

.el-button {
	width: 100%;
	background-color: var(--bg-color);
	border-color: var(--bg-color);
	color: #fff;
}

.el-button:hover {
	background-color: var(--bg-color-8);
	border: 1px solid var(--bg-color-8);
	color: var(--text-light-color);
}

a {
	margin-top: 20px;
	float: right;
	font-size: 0.875rem;
	color: var(--text-color);
	cursor: pointer;
}
</style>
